import styled from "@emotion/styled"
import { sm } from "../../styles/mediaQuery"

export const RegisterFormWrapper = styled.div`
  margin-top: 1.2em;
  margin-bottom: 40px;

  .ant-steps-item-icon {
    height: 32px !important;
  }

  ${sm} {
    .ant-form-item {
      margin-bottom: 20px;
    }

    .ant-form-item-label {
      padding-bottom: 0;
    }
  }
`
